var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('home-page-header-section'),_c('home-page-description-section'),_c('home-page-upper-cards-section'),_c('home-page-numbers-section'),_c('home-page-lower-cards-section'),_c('home-page-comments-section'),_c('home-page-try-for-free-section'),_c('home-page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }